import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import BubbleIcon from '@/components/interface/BubbleIcon.vue';
import Chip from '@/components/interface/Chip.vue';
import localization from '@/i18n';
import {
  getPackagePriceByProductLookupKey,
  getPackagePricesByType,
  getPackageQuota,
  packageHasFeature,
} from '@/lib/billing/billingFunctions';
import { Icon } from '@/lib/enum/Icon';
import { convertPenceToPounds, formatCurrency } from '@/util/currencyFunctions';
import { enumFromString } from '@/util/stringFunctions';
import { computed, ref } from 'vue';
import {
  BillingPackage,
  BillingPackageIntervalEnum,
  BillingProductFeaturesEnum,
  BillingProductTypeEnum,
  BillingQuotaDefinitionLookupKeyEnum,
} from '../../../../api/v1';


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageCardV2',
  props: {
    billingPackage: null,
    isCurrentPackage: { type: Boolean, default: false },
    canTrialPackage: { type: Boolean, default: false },
    canChoosePackage: { type: Boolean, default: false },
    showChoosePackage: { type: Boolean, default: false },
    mostPopular: { type: Boolean, default: false },
    collapseFeatures: { type: Boolean, default: false }
  },
  emits: ["trialPackage", "choosePackage"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'trialPackage', billingPackage: BillingPackage): void;
  (e: 'choosePackage', billingPackage: BillingPackage): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { billingPackage: BillingPackage, isCurrentPackage: boolean, canTrialPackage: boolean, canChoosePackage: boolean, showChoosePackage: boolean, mostPopular: boolean, collapseFeatures: boolean }





const showFeatures = ref(!props.collapseFeatures);
const packageFeaturesOrder = {
  1: BillingProductFeaturesEnum.Scheduler,
  2: BillingProductFeaturesEnum.Availability,
  3: BillingProductFeaturesEnum.HrManagement,
  4: BillingProductFeaturesEnum.Leave,
  5: BillingProductFeaturesEnum.Documents,
  6: BillingProductFeaturesEnum.ClockInOut,
  7: BillingProductFeaturesEnum.MultiVenue,
  8: 'Unlimited Support',
};

const planFeaturesList = computed(() =>
  Object.values(packageFeaturesOrder).reduce(
    (acc, featureName: BillingProductFeaturesEnum | string) => {
      acc.push({
        checked:
          featureName === 'Unlimited Support' ||
          packageHasFeature(
            props.billingPackage,
            enumFromString(BillingProductFeaturesEnum, featureName),
          ),
        name: localization.tc(`enum.planFeatures.${featureName}`),
      });
      return acc;
    },
    [],
  ),
);

const packagePlanPrice = computed(
  () =>
    (getPackagePricesByType(
      props.billingPackage,
      BillingProductTypeEnum.Plan,
    )[0]?.fixedPrice || 0) / 100,
);

const additionalEmployeesText = computed<string>(() => {
  const employeePricing = getPackagePriceByProductLookupKey(
    props.billingPackage,
    'employees',
  );

  if (employeePricing.fixedPrice !== null) {
    return localization.tc('info.account.additionalEmployeesCost', 1, {
      rate: formatCurrency(employeePricing.fixedPrice, 'GBP'),
    });
  }

  const { tiers } = employeePricing;
  const lines = tiers.map((t) => {
    if (t.quantityEnd === null) {
      return localization.tc('info.account.additionalEmployeesTierLast', 1, {
        start: t.quantityStart,
        rate: formatCurrency(convertPenceToPounds(t.unitPrice), 'GBP'),
      });
    }

    return localization.tc('info.account.additionalEmployeesTierN', 1, {
      start: t.quantityStart,
      end: t.quantityEnd,
      rate: formatCurrency(convertPenceToPounds(t.unitPrice), 'GBP'),
    });
  });

  lines.splice(
    0,
    0,
    localization.tc('info.account.additionalEmployeesBilledAtRates'),
  );

  return lines.join('\n');
});

return { __sfc: true,props, emit, showFeatures, packageFeaturesOrder, planFeaturesList, packagePlanPrice, additionalEmployeesText, Button, BubbleIcon, Chip, getPackageQuota, Icon, formatCurrency, BillingPackageIntervalEnum, BillingQuotaDefinitionLookupKeyEnum }
}

})